// eventBus.ts
type EventCallback = (payload: unknown) => void;

class EventBus {
  private events: Record<string, EventCallback[]> = {};

  on<T = any>(event: string, callback: (payload: T) => void) {
    if (!this.events[event]) {
      this.events[event] = [];
    }
    this.events[event].push(callback);
  }

  off<T = any>(event: string, callback: (payload: T) => void) {
    if (!this.events[event]) return;
    this.events[event] = this.events[event].filter((cb) => cb !== callback);
  }

  emit<T = any>(event: string, payload: T) {
    if (!this.events[event]) return;
    this.events[event].forEach((callback) => {
      callback(payload);
    });
  }
}

export default new EventBus();
